import { cardResource, CardResource } from '@witkac/kartamiejska-resources';
import { Card } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';
import { LocalStorage } from '@/enums/storage.enum';

/**
 * Moduł kart klienta
 *
 * @class ClientCardModule
 * @extends {EntityModule<Card, CardResource>}
 */
class CardsModule extends EntityModule<Card, CardResource> {
  constructor() {
    super(cardResource);
    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę kart klienta
       *
       * @param context context
       */
      list: async (context: any): Promise<void> => {
        const id = localStorage.getItem(LocalStorage.USER_ID) as any;
        const list = await this.resource.cardsById(id);
        context.commit('saveList', list);
      },

      /**
       * Blokuje kartę
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<void>}
       */
      block: (context: any, variables: any): Promise<void> => this.resource.block(variables),

      /**
       * Deaktywuje kartę
       *
       * @param {*} context
       * @param {*} variables
       * @returns {Promise<void>}
       */
      deactivate: (context: any, variables: any): Promise<void> => this.resource.deactivate(variables)
    };
  }
}
export default new CardsModule();
